import ATableAccess from "./aTableAccess";

class AbsenceAccess extends ATableAccess {}

export default AbsenceAccess;
